import type { MouseEvent, MouseEventHandler } from 'react'

export type ButtonClickHandler =
	| MouseEventHandler<HTMLButtonElement>
	| (() => Promise<unknown> | unknown)

export function runButtonClick({
	event,
	onClick,
	isLoading,
	setAsyncLoading
}: {
	event: MouseEvent<HTMLButtonElement>
	onClick?: ButtonClickHandler
	isLoading: boolean
	setAsyncLoading: (value: boolean) => void
}) {
	if (onClick == null || isLoading) return

	const result = Reflect.apply(onClick, undefined, [event])
	if (result instanceof Promise) {
		setAsyncLoading(true)
		result.finally(() => setAsyncLoading(false))
	}
	return result
}
